module.exports = __webpack_public_path__ + "img/16_123.6036edf7.png";